import { render, staticRenderFns } from "./MassiveLoad.vue?vue&type=template&id=4404b5f6"
import script from "./MassiveLoad.vue?vue&type=script&lang=js"
export * from "./MassiveLoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports